// components/common/popover/QuestionInfoPopover.tsx
import React from 'react'
import { makeStyles, tokens } from '@fluentui/react-components'
import { t } from 'i18next'
import { DemandAnalysisQuestion } from '../../../../api/schemas/schema'
import { RTFOutput } from '../../../common/outputs/RTFOutput'
import { InformationPopover } from '../../../common/popover/InformationPopover'

type QuestionInfoPopoverProps = {
   item: DemandAnalysisQuestion
   btnLabel: string
   popoverLabel: string
   regularIcon: JSX.Element
   filledIcon: JSX.Element
   pickText: (item: DemandAnalysisQuestion) => string | undefined | null
   renderLink?: (item: DemandAnalysisQuestion) => JSX.Element | null
   position?: any
   className?: string
}

const useStyles = makeStyles({
   column: {
      display: 'flex',
      flexDirection: 'column',
      gap: tokens.spacingVerticalM,
      '@media screen and (max-width: 1007px)': {
         '& > *': { display: 'flex', flexDirection: 'column' },
      },
   },
})

export const QuestionInfoPopover = ({
   item,
   btnLabel,
   popoverLabel,
   regularIcon,
   filledIcon,
   pickText,
   renderLink,
   position,
   className,
}: QuestionInfoPopoverProps) => {
   const classes = useStyles()

   const text = pickText(item)?.trim() || t('NoAvailableInformation')

   const body = (
      <article className={classes.column}>
         <section>
            <RTFOutput text={text} />
         </section>
      </article>
   )

   return (
      <InformationPopover
         btnLabel={btnLabel}
         popoverLabel={popoverLabel}
         regularIcon={regularIcon}
         filledIcon={filledIcon}
         input={body}
         link={renderLink ? renderLink(item) : undefined}
         position={position}
         className={className}
      />
   )
}
